import { put, call, all, takeLatest } from 'redux-saga/effects';

import { contactAPIs } from 'apis/services';
import { ActionTypeEnum } from 'redux/ActionTypeEnum';
import { loadingAction, snackbarAction } from 'redux/settings/action';

function* contactRequest({ payload, meta }) {
	try {
		yield put(loadingAction({ form: true }));
		const response = yield call(contactAPIs.setContact, payload);
		yield put(
			snackbarAction({
				message: response.data?.Message,
				severity: 'success',
			}),
		);
		yield put(loadingAction({ form: false }));
		meta?.rf?.();
	} catch (error) {
		yield put({ type: ActionTypeEnum.error, payload: error, meta });
	}
}
export default function* contactSaga() {
	yield all([takeLatest(ActionTypeEnum.contact_data_request, contactRequest)]);
}
